// api consts

export const baseUrl = "https://rajatdhiman30.pythonanywhere.com/data/";
export const projectUrl = "project";
export const contactUrl = "contact_us";
export const feedbackUrl = "feedback";
export const clientUrl = "client";
